import {
  HOST,
  DEBUG_MODE,
  ARWEAVE_GATEWAY,
  GLOBAL_RAW_ENTRIES_ARTISTS_AND_GENRECONTRACTS_FETCH_AND_RESPONSE_CACHE_REVALIDATE_MINUTES,
  PRACTICAL_STREAM_CDN_ADDRESS,
} from './config'
import { toTrimmedStringLowerCase } from './misc'

const USE_CDN_FOR_GENRE_IMAGES: boolean = true

// #region Genre Images - PNG / JPG
const GENRE_IMAGE_AFRICA: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'vjKEXMsBCfizLYflKvGHmSO6enHV7muu6GZVMWyg3fQ' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_POP: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'D5thlq7pJ3CrWw7b9Mww_EOZd4u_YPtjFomNKbdrZSc' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_BLUES: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'SfMG64ulhkAckoqSLaY3Xp0W4UXa0nSyHKBtJ4MnAr0' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_COMEDY: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'VST9KeoK631vFn7fcrMfaNd3xVZBMeqWBMuqmIg2AR4' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_COUNTRY: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'xM6KsavzWcV_hFlCTwNOEcU0TNu5QsUFaVvMOKlh46w' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_CLASSICAL: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'kns6FpRjkDNwBr-BWdvZ408lXWiTuhOby4RfFFPlpDM' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_DANCE: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'yptPmzHCfiaMLxMPDh6UujKLEvJzvddv7xp8UV_0zHE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_ELECTRONIC: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'hfVbTyx2OS5bUa1_DCm-BhSx2Uyf6pY3EqrCvpIeK5g' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_FOLK: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'fIsSyx80IBS4AO9Bc1XpdVJ3TH4qNRSzG8WYOToA8OE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_HIPHOP: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'ZAom9P7Qf7QCXtUZSwBid31fX4sLhMCEvr1T2xDfMkE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_JAZZ: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'ANFhHQlwh7kHztOSUbJv__gnunFfNPrcTpttDmgEkps' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_KIDS: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'duIPSeGQ8Nl0nlrWoinVqEe6IfS3J8gtUAug58UGOsU' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_LATIN: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'KUjHraf-la5wOgwJV-OmF-5W8Ns7PWVMkX6lEy0LFHo' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_GLOBAL: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'uA4CQxn99YQbp07rO5JRzg8nXYWLOMULGJn-Rohklqo' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_OLDIES_MOTOWN: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'uHKyUAPZ60-ZeF3FA6_rjv_228PupKzdtP99I_cexko' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_METAL: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'O8QEe1Y0Ex9ZMJ4t3klS96EFZ0CSYFIMCVwXYghWoxs' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_ROCK_INDIE: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'EzM67FDEE5g63pJNMO5wb2PK17IDSyz7Pq9zlhhUbTE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_R_AND_B_SOUL: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'MYLqBR7Gv5SPv6CNgcEDL8Fq60zu1m9QMxIB3n0dJJc' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_INSTRUMENTALS: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'cPRL3rFRXMFZesxyCwf1X9TSNThWJUtcUiRto2NHCDU' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_REGGAE_DANCEHALL: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'hyFagNNWdjiN_zgry_VDGT0apGRZPMnftvqLXI5RxeY' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
// #endregion

// #region Genre Images - AVIF
const GENRE_IMAGE_AFRICA_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'RiHYEbljoPiJAUVY5rRT2Aux4Iod6FnKM63vnf3Pf_Q' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_POP_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'XnDELaGRrNF9mklUSLLP91PVMaq4K1FvTiRBy2n07MM' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_BLUES_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'kh1hPlpPUmrdp9URq13xMrycsyW5XeYDU65fezPJrm8' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_COMEDY_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '0rTzTSFqo_qrOIoYWia7ksf36S2_lM_acNY2omlFeK8' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_COUNTRY_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'PEOB6RdOFUQ6kE-aWFKJ9c6yk7Ub4U_iT54CU8RzWpo' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_CLASSICAL_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'dPcNLYW3EZEk08ylfuUxBiVRtMJp2XQjeC68dt4H8Vo' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_DANCE_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'V19fuKAISo_mlorIxpUhsWGkyCjjPXl4xPV_9QrU4HY' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_ELECTRONIC_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'tDDKiPQaYR6CxT0dwO9YAmnGj6GKDv3g17Y6Eg0Zwiw' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_FOLK_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'BCYyoZnyCjcrjck61uu6a2vTLLmYTPW7gXUvaVjD4zI' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_HIPHOP_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '-Niy6LMJsiyyccsLavWwDuVyKJ3DaNE_0HUDJWtwLh0' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_JAZZ_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'm1NImW_A0UgQfA_V0b3BH6XxTnKBsn3L7oiXGzqfC1c' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_KIDS_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'fnKZTwPFRwwUCzumTmuyhjMLUBBEnghJT4M3I_CvgiI' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_LATIN_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'Rr9BPzE4wBbjfE0p5ioEZ5qCm3qPF_ukMUSeRxTg8t8' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_GLOBAL_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'Md6B_hFTxiB4aM6nrGX8vvsnFGgld6gdx5dsJ2DwtwI' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_OLDIES_MOTOWN_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'FsJ9sYFb4PIFE8f74_5BEs0u--Of5B7AZTSkyK__xRg' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_METAL_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'CJ0FyaCuCd0sk2tq2IAKMSrRBWaEtfWEUV8UK8r0M5o' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_ROCK_INDIE_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'DN23ccWTsaZmFG_md7fHXFn8CevnBIDR5hZSSYUxVTE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_R_AND_B_SOUL_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'zdQzIuRasE4GEcN4iPDQc-xhXyRCPdl9TVdTjLxFX00' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_IMAGE_INSTRUMENTALS_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '8YVf_JAaemZcL6y7cfkNOnTR_2duxjcIlPPoaTduUsI' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
const GENRE_REGGAE_DANCEHALL_AVIF: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'er_J-AZz8hR_-6VQeRAe7NuqnONNxcy5pv1tWoP-DlA' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.avif' : '')
// #endregion

// #region Genre Thumbs - PNG / JPG
const GENRE_IMAGE_AFRICA_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'jIuhhJsDScL-PiiHDqRFKqHatN0-aL2kX6rr097E83s' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_POP_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '-UmxuU0BLoTCRESYW9RAvZL5D95KYOPTdt_V_Zv8NLs' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_BLUES_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'JkEzh6lyuXFHaIrb8OUaqUazmYC2QWT-jXYsOuQWRTw' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_COMEDY_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '0FPnXosMmGuuXe17YzBBGzorJ3tiftl69h3smfTpMYA' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_COUNTRY_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'Z9uimOyznGAYvgzmypPXSGqOH1a4SijuM1fmPKgrUuk' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_CLASSICAL_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'Dz1s6UXrYB0xqQG1ntyf13x8qqtT6hFhmjFlX05y4m8' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_DANCE_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'iCqYr1S-WzE2g1GFHz6ohULO4-txHYati_BRF6cdGps' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_ELECTRONIC_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'hOFDkmTuhV9O5PoRQJK7lwXqvcu_d8rslfkPbHunJmc' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_FOLK_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'upzPMb9PbYC0FdZ0qd-OWLPX8VHMq3QaRy1-B21teaA' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_HIPHOP_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'uv2tpKtOu6nWbcQXP_lEoIZEXqRo6QfFByuJDkEUZxs' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_JAZZ_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'arNK8rWGXU8w-aHptMzNpP29Ul2WAvTXxjkKUhIgVTY' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_KIDS_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'PwHg7qPT4yefdXw48PCJCkInKPyQlaRXKQXYK_Qhrks' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_LATIN_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'WF4TKc-smWa3ARhRVUi8IPE2ixEfqKApPBchJn1zIuE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_GLOBAL_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'flNNZXVcy-2HV0NJJ0Wofs3tF9Ij3ohubkHbyXSl0w0' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_OLDIES_MOTOWN_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '-sEm6vSIiaxo38BhMQyOIwlR1_6oxv5eYr6lRfkE6BM' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_METAL_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'HGk24gNzeW7xBIXf2TSRqqqew3iKfgfKc18tWs2MSO4' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_ROCK_INDIE_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'cudw8xdOh9HESCQMiNKRX-zubTs-wzXNYF_mxGuUU2A' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_R_AND_B_SOUL_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'n4DXH40jVEwLfKpY-c0RZMHzy42JAj9nYcglDJUR5PE' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_IMAGE_INSTRUMENTALS_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  '4BCiJeezQq0p9Hm6GEaLMuWy9fQRB-DV4ZhR_8vnx-A' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
const GENRE_REGGAE_DANCEHALL_THUMB: string =
  (USE_CDN_FOR_GENRE_IMAGES
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
    : ARWEAVE_GATEWAY) +
  'wTXrhyVLoc72lmORDQ09uGiY_55MwgaOPdM8nyps_hM' +
  (USE_CDN_FOR_GENRE_IMAGES ? '.jpg' : '')
//#endregion

export function getThumbForGenre(genre: any, useAvif: any) {
  let ret: string = ''
  let frmGenre: string = toTrimmedStringLowerCase(genre)
  try {
    if (frmGenre == 'pop')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'B39773AD-E0EE-46F9-96A6-B2380DB747C5.avif'
        : GENRE_IMAGE_POP_THUMB
    else if (frmGenre == 'blues')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '2F373D19-6BD7-4E92-BEBE-30FB7BC43BAF.avif'
        : GENRE_IMAGE_BLUES_THUMB
    else if (frmGenre == 'africa')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '7F2C7602-8F62-42DA-B3DE-EB810A32BB82.avif'
        : GENRE_IMAGE_AFRICA_THUMB
    else if (frmGenre == 'comedy')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '1D42EF17-3E5D-4CA0-8187-26A2FC6545C0.avif'
        : GENRE_IMAGE_COMEDY_THUMB
    else if (frmGenre == 'classical')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '5F00B960-310E-4650-9AC1-8B9757ECF442.avif'
        : GENRE_IMAGE_CLASSICAL_THUMB
    else if (frmGenre == 'country')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'B64C58EA-5920-4FAD-8476-03F63C3190EC.avif'
        : GENRE_IMAGE_COUNTRY_THUMB
    else if (frmGenre == 'dance')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '6CEC9726-651E-48BC-8272-FBA75CF96C92.avif'
        : GENRE_IMAGE_DANCE_THUMB
    else if (frmGenre == 'electronic')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'DEC4465F-BD3B-473E-B7BC-6BCB8E961284.avif'
        : GENRE_IMAGE_ELECTRONIC_THUMB
    else if (frmGenre == 'folk / american')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'F0886BA5-49D2-428C-986C-4F83FFEF0D2B.avif'
        : GENRE_IMAGE_FOLK_THUMB
    else if (frmGenre == 'rap / hip-hop')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'FE51B61A-FD29-4CF4-BE7E-EF19F549A1A1.avif'
        : GENRE_IMAGE_HIPHOP_THUMB
    else if (frmGenre == 'jazz')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '0589F30F-20E7-4F18-90DD-23F307FF499B.avif'
        : GENRE_IMAGE_JAZZ_THUMB
    else if (frmGenre == 'kids')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'C13E7793-F1A2-4698-8E51-6B44445B58BB.avif'
        : GENRE_IMAGE_KIDS_THUMB
    else if (frmGenre == 'latin')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'EABC8249-8107-4E22-BEAC-D0F6B8E8B0F9.avif'
        : GENRE_IMAGE_LATIN_THUMB
    else if (frmGenre == 'global')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '6CEC9726-651E-48BC-8272-FBA75CF96C92.avif'
        : GENRE_IMAGE_GLOBAL_THUMB
    else if (frmGenre == 'oldies / motown')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '6B90A478-743D-450A-86FC-4D2B8678B566.avif'
        : GENRE_IMAGE_OLDIES_MOTOWN_THUMB
    else if (frmGenre == 'metal')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '855A0A9C-7660-4FB3-A84B-B9FBD7E6C486.avif'
        : GENRE_IMAGE_METAL_THUMB
    else if (frmGenre == 'rock')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'A738526C-91D2-41F6-9C4D-A5642FF0297E.avif'
        : GENRE_IMAGE_ROCK_INDIE_THUMB
    else if (frmGenre == 'r&b / soul')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'E0E68F2E-0DA9-4F02-A006-DA5D1734990A.avif'
        : GENRE_IMAGE_R_AND_B_SOUL_THUMB
    else if (frmGenre == 'instrumentals')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          '620F138A-BDA4-4981-9135-71B891BCDE96.avif'
        : GENRE_IMAGE_INSTRUMENTALS_THUMB
    else if (frmGenre == 'reggae / dancehall')
      ret = useAvif
        ? PRACTICAL_STREAM_CDN_ADDRESS +
          'a/' +
          'C173AEAE-5E8E-4ED9-9D8F-515F25460C46.avif'
        : GENRE_REGGAE_DANCEHALL_THUMB
    else ret = ''
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getImageForGenre(genre: any, avifCompatible: boolean | null) {
  let ret: string = ''
  let frmGenre: string = toTrimmedStringLowerCase(genre)
  try {
    if (frmGenre == 'pop')
      ret = avifCompatible ? GENRE_IMAGE_POP_AVIF : GENRE_IMAGE_POP
    else if (frmGenre == 'blues')
      ret = avifCompatible ? GENRE_IMAGE_BLUES_AVIF : GENRE_IMAGE_BLUES
    else if (frmGenre == 'africa')
      ret = avifCompatible ? GENRE_IMAGE_AFRICA_AVIF : GENRE_IMAGE_AFRICA
    else if (frmGenre == 'comedy')
      ret = avifCompatible ? GENRE_IMAGE_COMEDY_AVIF : GENRE_IMAGE_COMEDY
    else if (frmGenre == 'classical')
      ret = avifCompatible ? GENRE_IMAGE_CLASSICAL_AVIF : GENRE_IMAGE_CLASSICAL
    else if (frmGenre == 'country')
      ret = avifCompatible ? GENRE_IMAGE_COUNTRY_AVIF : GENRE_IMAGE_COUNTRY
    else if (frmGenre == 'dance')
      ret = avifCompatible ? GENRE_IMAGE_DANCE_AVIF : GENRE_IMAGE_DANCE
    else if (frmGenre == 'electronic')
      ret = avifCompatible
        ? GENRE_IMAGE_ELECTRONIC_AVIF
        : GENRE_IMAGE_ELECTRONIC
    else if (frmGenre == 'folk / american')
      ret = avifCompatible ? GENRE_IMAGE_FOLK_AVIF : GENRE_IMAGE_FOLK
    else if (frmGenre == 'rap / hip-hop')
      ret = avifCompatible ? GENRE_IMAGE_HIPHOP_AVIF : GENRE_IMAGE_HIPHOP
    else if (frmGenre == 'jazz')
      ret = avifCompatible ? GENRE_IMAGE_JAZZ_AVIF : GENRE_IMAGE_JAZZ
    else if (frmGenre == 'kids')
      ret = avifCompatible ? GENRE_IMAGE_KIDS_AVIF : GENRE_IMAGE_KIDS
    else if (frmGenre == 'latin')
      ret = avifCompatible ? GENRE_IMAGE_LATIN_AVIF : GENRE_IMAGE_LATIN
    else if (frmGenre == 'global')
      ret = avifCompatible ? GENRE_IMAGE_GLOBAL_AVIF : GENRE_IMAGE_GLOBAL
    else if (frmGenre == 'oldies / motown')
      ret = avifCompatible
        ? GENRE_IMAGE_OLDIES_MOTOWN_AVIF
        : GENRE_IMAGE_OLDIES_MOTOWN
    else if (frmGenre == 'metal')
      ret = avifCompatible ? GENRE_IMAGE_METAL_AVIF : GENRE_IMAGE_METAL
    else if (frmGenre == 'rock')
      ret = avifCompatible
        ? GENRE_IMAGE_ROCK_INDIE_AVIF
        : GENRE_IMAGE_ROCK_INDIE
    else if (frmGenre == 'r&b / soul')
      ret = avifCompatible
        ? GENRE_IMAGE_R_AND_B_SOUL_AVIF
        : GENRE_IMAGE_R_AND_B_SOUL
    else if (frmGenre == 'instrumentals')
      ret = avifCompatible
        ? GENRE_IMAGE_INSTRUMENTALS_AVIF
        : GENRE_IMAGE_INSTRUMENTALS
    else if (frmGenre == 'reggae / dancehall')
      ret = avifCompatible
        ? GENRE_REGGAE_DANCEHALL_AVIF
        : GENRE_REGGAE_DANCEHALL
    else ret = ''
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const GET_CONTRACTS_FOR_GENRES_CALLSTRING: string[] = [
  `self.addEventListener('message', async (event) => {
      if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
        try {
          if (event?.data?.genreId != null && event?.data?.genreId?.toString().trim() != '') {
            const opts = {
              method: 'GET',
              headers: {
                'genreId': event?.data?.genreId,
              },
              next: { revalidate: ${(
                GLOBAL_RAW_ENTRIES_ARTISTS_AND_GENRECONTRACTS_FETCH_AND_RESPONSE_CACHE_REVALIDATE_MINUTES *
                60
              ).toString()} }, 
            }
            await fetch('${HOST}' + '/api/p.stream-sv/g/ggc', opts)
              .then(async (x) => {
                const ret = await x.json()
                self.postMessage(ret?.genreContracts?.length > 0 ? ret?.genreContracts : [])
              })
              .catch((e) => {
                if (${DEBUG_MODE}) console.log(e)
                self.postMessage([])
              })
          } else self.postMessage([])
        } catch (e) {
          if (${DEBUG_MODE}) console.log(e)
          self.postMessage([])
        }
      } else self.postMessage([])
    })`,
]

export const STATIC_GENRES = [
  {
    value: 1,
    label: 'Africa',
    labelSpanish: 'África',
    labelFrench: 'Afrique',
    labelKorean: '아프리카',
  },
  {
    value: 2,
    label: 'Blues',
    labelSpanish: 'Blues',
    labelFrench: 'Blues',
    labelKorean: '블루스',
  },
  {
    value: 3,
    label: 'Classical',
    labelSpanish: 'Clásico',
    labelFrench: 'Classique',
    labelKorean: '클래식',
  },
  {
    value: 4,
    label: 'Comedy',
    labelSpanish: 'Comedia',
    labelFrench: 'Comédie',
    labelKorean: '코메디',
  },
  {
    value: 5,
    label: 'Country',
    labelSpanish: 'Country',
    labelFrench: 'Country',
    labelKorean: '컨트리',
  },
  {
    value: 6,
    label: 'Dance',
    labelSpanish: 'Baile',
    labelFrench: 'Danse',
    labelKorean: '댄스',
  },
  {
    value: 7,
    label: 'Electronic',
    labelSpanish: 'Electrónica',
    labelFrench: 'Électronique',
    labelKorean: '일렉트로닉',
  },
  {
    value: 20,
    label: 'Instrumentals',
    labelSpanish: 'Instrumentales',
    labelFrench: 'Instrumentaux',
    labelKorean: '인스트루멘탈 ',
  },
  {
    value: 11,
    label: 'Jazz',
    labelSpanish: 'Jazz',
    labelFrench: 'Jazz',
    labelKorean: '재즈',
  },
  {
    value: 12,
    label: 'Kids',
    labelSpanish: 'Niños',
    labelFrench: 'Enfants',
    labelKorean: '키즈',
  },
  {
    value: 13,
    label: 'Latin',
    labelSpanish: 'Latino',
    labelFrench: 'Latine',
    labelKorean: '라틴',
  },
  {
    value: 15,
    label: 'Metal',
    labelSpanish: 'Metal',
    labelFrench: 'Métal',
    labelKorean: '메탈',
  },
  {
    value: 14,
    label: 'Oldies / Motown',
    labelSpanish: 'Clásicos / Motown',
    labelFrench: 'Oldies / Motown',
    labelKorean: '올디스 / 모타운',
  },
  {
    value: 16,
    label: 'Pop',
    labelSpanish: 'Pop',
    labelFrench: 'Pop',
    labelKorean: '팝',
  },
  {
    value: 18,
    label: 'R&B / Soul',
    labelSpanish: 'R&B / Soul',
    labelFrench: 'R&B / Soul',
    labelKorean: 'R&B / 소울',
  },
  {
    value: 10,
    label: 'Rap / Hip-Hop',
    labelSpanish: 'Rap / Hip-Hop',
    labelFrench: 'Rap / Hip-Hop',
    labelKorean: '랩 / 힙합',
  },
  {
    value: 21,
    label: 'Reggae / Dancehall',
    labelSpanish: 'Reggae / Dancehall',
    labelFrench: 'Reggae / Dancehall',
    labelKorean: '레게 / 댄스홀',
  },
  {
    value: 17,
    label: 'Rock',
    labelSpanish: 'Rock',
    labelFrench: 'Rock',
    labelKorean: '록',
  },
]
